export const USER_CATEGORIES = ['standard', 'trial', 'inhouse', 'disabled'] as const

export type UserCategory = (typeof USER_CATEGORIES)[number]

/** Alias for kysely-codegen (`users.user_category`). */
export type UserCategoryType = UserCategory

export const USER_CATEGORY_FILTER_VALUES = ['all', ...USER_CATEGORIES] as const

export type UserCategoryFilter = (typeof USER_CATEGORY_FILTER_VALUES)[number]

export function userCategoryAdminLabel(category: string | null | undefined): string {
    switch (category) {
        case 'standard':
            return 'Betalande'
        case 'trial':
            return 'Test'
        case 'inhouse':
            return 'Finance Lab'
        case 'disabled':
            return 'Inaktiv'
        default:
            return category ?? '—'
    }
}
